<!-- 图文详情 -->
<template>
    <div
        v-if="componentsData.type == 8"
        class="bg-div"
        :class="{ 'overflow-hidden': showBtn }"
        :style="bgStyle"
    >
        <!-- 多场景模式：根据 sceneIndex 渲染对应场景内容 -->
        <template v-if="hasScenes">
            <div
                :class="sceneBtnClass"
                :style="sceneContentStyle"
            >
                <div class="ql-editor" v-html="currentScene.text"></div>
                <div v-if="currentScene.btn_value" class="mask-div">
                    <div
                        class="btn"
                        :style="{
                            background: currentScene.btn_color,
                            borderColor: currentScene.border_color,
                            color: currentScene.btn_text_color,
                        }"
                    >
                        查看更多
                    </div>
                </div>
            </div>
        </template>
        <!-- 普通模式：渲染原有图文内容 -->
        <template v-else>
            <div class="ql-editor" v-html="componentsData.content.text"></div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        // 多场景模式下的场景索引（0=场景一, 1=场景二, 2=场景三），由溯源码页面后端接口返回值决定
        sceneIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {};
    },
    computed: {
        // 是否使用多场景模式
        hasScenes() {
            return (
                this.componentsData.content &&
                Array.isArray(this.componentsData.content.scenes) &&
                this.componentsData.content.scenes.length > 0
            );
        },
        // 当前激活的场景数据（优先读取 content.scene_value，兼容编辑面板场景切换和溯源码页面 sceneIndex 传入）
        currentScene() {
            if (this.hasScenes) {
                // scene_value 为 1-based（1/2/3），sceneIndex 为 0-based（0/1/2）
                // 优先使用 content.scene_value 转换，为 0 时回退到 sceneIndex prop
                const contentSceneVal = this.componentsData.content.scene_value;
                const idx = contentSceneVal ? contentSceneVal - 1 : (this.sceneIndex || 0);
                return (
                    this.componentsData.content.scenes[idx] ||
                    this.componentsData.content.scenes[0] ||
                    { text: "", btn_value: 0 }
                );
            }
            return { text: this.componentsData.content.text || "", btn_value: this.componentsData.content.btn_value || 0 };
        },
        // 是否显示按钮展开区域
        showBtn() {
            if (this.hasScenes) {
                return this.currentScene.btn_value == 1;
            }
            return this.componentsData.content.btn_value == 1;
        },
        // 场景内容样式类名
        sceneBtnClass() {
            if (this.showBtn) {
                return "scene-content has-btn";
            }
            return "scene-content";
        },
        // 场景内容最大高度（按钮展开时显示蒙版）
        sceneContentStyle() {
            if (this.showBtn) {
                return { maxHeight: "200px" };
            }
            return {};
        },
        // 背景样式
        bgStyle() {
            const c = this.componentsData.content;
            if (c.version) {
                return {
                    ...(c.bg_color && { backgroundColor: c.bg_color }),
                    ...(c.bg_img && c.bg_img.picview && c.bg_value && {
                        backgroundImage: `url(${c.bg_img.picview})`,
                    }),
                    padding: `${c.paddingData.top}px ${c.paddingData.left}px`,
                    margin: `${c.marginData.top}px ${c.marginData.left}px`,
                    borderRadius: `${c.radiusData.top}px ${c.radiusData.top}px ${c.radiusData.bottom}px ${c.radiusData.bottom}px`,
                };
            }
            return `padding: ${c.marginData.top}px ${c.marginData.left}px;background: ${c.bg_color};border-radius: ${c.marginData.topRadius}px ${c.marginData.topRadius}px ${c.marginData.bottomRadius}px ${c.marginData.bottomRadius}px`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.overflow-hidden {
    overflow: hidden;
}
.scene-content.has-btn {
    position: relative;
    overflow: hidden;
}
.scene-content.has-btn::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        var(--mask-color, rgba(255, 248, 244, 0.95)) 100%
    );
}
.mask-div {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}
.btn {
    padding: 8px 36px;
    background: #fff;
    border: 1px solid #ff761d;
    border-radius: 20px;
    color: #ff761d;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
}
::v-deep .ql-editor {
    padding: 0px !important;
}
::v-deep .ql-editor img {
    width: 100% !important;
}
</style>